import { useMutation } from "react-query";
import API from "services";

export const useTrackStockMediaDownload = () => {
  return useMutation((downloadLocation: string) =>
    API.services.designStudio.trackStockMediaDownload({ downloadLocation }),
  );
};
